import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableDocumentReferencesPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableDocumentReferencesPage;
